import React from "react";

export default function Table({ data = [], onPageNext, onPagePrev }) {
  const btnProps = {
    style: {
      height: "2rem",
      padding: "0 1rem",
    },
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table table-hover table-bordered table-striped">
          <thead>
            <tr>
              <th>Id</th>
              <th>Username</th>
              <th>Nombre</th>
              <th>Departamento</th>
              <th>Municipio</th>
              {/* <th>Edad</th>*/}
              <th>Sexo</th>
              <th>Correo</th>
              <th>Telefono</th>
              <th>Fecha de creación</th>
              <th>Fecha de modificación</th>
              <th>Estado</th>
              <th>Perfil Completado</th>
              <th>Ultima Conexion</th>
            </tr>
          </thead>

          <tbody>
            {data.map((elm, i) => {
              return (
                <tr key={i}>
                  <td>{elm.userId}</td>
                  <td>{elm.username}</td>
                  <td>{elm.nombre}</td>
                  <td>{elm.departamento}</td>
                  <td>{elm.municipio}</td>
                  {/* <td>{elm.edad}</td>*/}
                  <td>{elm.sexo}</td>
                  <td>{elm.correo}</td>
                  <td>{elm.telefono}</td>
                  <td>{elm.fechaCreacion}</td>
                  <td>{elm.fechaModificacion}</td>
                  <td>{elm.estado}</td>
                  <td>{elm.profileCompleted ? "Completado" : "Incompleto"}</td>
                  <td>{elm.lastAccess}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="btn-group mt-3" role="group" aria-label="Basic example">
        <button
          {...btnProps}
          className="btn btn-secondary"
          onClick={onPagePrev}
        >
          {"<"}
        </button>
        <button
          {...btnProps}
          className="btn btn-secondary"
          disabled={data.length < 20}
          onClick={onPageNext}
        >
          {">"}
        </button>
      </div>
    </>
  );
}
